/*eslint-disable*/export const messages=JSON.parse("{\"forms.field.label.optional\":[\"(valgfrit)\"],\"forms.validation.mandatoryField\":[\"Skal udfyldes\"]}");